import { Fragment, useState , } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
// import axios from "axios";

import AuthLayout from "../../../components/layouts/AuthLayout";
import EncryptHelper from "../../../utils/helpers/encryptHelper";
import ActionCreator from "../../../utils/helpers/actionCreator";
import { setLoggedInUser } from "../../../store/actions/auth.action";
import ProfileService from "../../../utils/services/profile.service";
import * as AuthConstants from "../../../store/constants/auth.constants";
import {
  Loading,
  UserType,
} from "../../../utils/helpers/constants";
// import DynamicFields from "../../../components/dynamicFields/DynamicFields";

// import GoogleSVG from "../../../assets/images/svg/google.svg";
import { 
    // useGoogleLogin ,
    
    GoogleLogin} from "@react-oauth/google";

// import AuthService from "../../../utils/services/auth.service";
// import TokenHelper from "../../../utils/helpers/tokenHelper";

const Body = ({
  passwordPolicy,
  authPolicy,
  dynamicFields,
  dynamicRender,
  properties,
}) => {
  const dispatch = useDispatch(),
    navigate = useNavigate()
    // , isLoggedIn = TokenHelper.checkIfLoggedIn();
//   const [loadingStatus, setLoadingStatus] = useState(false);

//   const [loadingSocialAuth, setLoadingSocialAuth] = useState(false);
  const [, setLoadingSocialAuth] = useState(false);


//   const useFormHook = useForm({
//     defaultValues: {},
//     mode: "all",
//     reValidateMode: "onChange",
//     criteriaMode: "firstError",
//   });

  const onSubmitClick = async () => {
    navigate("/auth/register/");
  };

  const handleGoogleAuth = async (payload) => {
    setLoadingSocialAuth(true);
    // const { data: responseData } = await AuthService.validateOAuth(
    //   payload,
    //   UserType.CUSTOM_USER,
    // );
    // const userInfo = await axios
    // .get('https://www.googleapis.com/oauth2/v3/userinfo', {
    //   headers: { Authorization: `Bearer ${payload.token}` },
    // })

    // console.log("Google User Info", userInfo);
    const { data: responseData } = await ProfileService.signupOAuth(
      payload,
      UserType.CUSTOM_USER,
    );
    await setLoadingSocialAuth(false);
    if (responseData.status !== Loading.SUCCESS)
      toast.error(responseData.message);
    else {
        console.log("Google Signup Response", responseData);
        toast.success(responseData.message);
        const user = EncryptHelper.jwtDecode(responseData.data.access);
        await dispatch(setLoggedInUser(responseData.data.access, user));
        await dispatch(ActionCreator(AuthConstants.LOGIN_SUCCESS, true));
        navigate('/');
    }
    setLoadingSocialAuth(false);
  };

//   const googleCallbackResponse = useGoogleLogin({
//     onSuccess: (response) =>{
//       console.log("Google Response", response);
//       handleGoogleAuth({ token: response["code"], platform: "GOOGLE" })
//     },
//     flow: 'auth-code',
//   });

//   const renderDynamicFields = dynamicFields.map((eachField, index) => (
//     <DynamicFields
//       divClass="form-group text-start pos-relative"
//       inputClass="form-control"
//       key={index}
//       formControl={eachField}
//       formHook={useFormHook}
//     />
//   ));

  return (
    <Fragment>
      <AuthLayout favicon={properties["favicon"]} logo={properties["logo"]}>
        <form className="login-form signup-page">
          <button className="log-in" onClick={onSubmitClick} type="button">
            Sign up with email
          </button>

          {authPolicy["socialAuth"] && (
            <Fragment>
              {authPolicy["socialAuthOptions"]["googleAuth"] && (
                <>
                  <p id="or" className="mt-3">
                    Or
                  </p>
                  <GoogleLogin
                    // size="large"
                    text="signup_with"
                    // text="continue_with"

                    onSuccess={credentialResponse => {
                        console.log(credentialResponse);
                        handleGoogleAuth({ token: credentialResponse["credential"], platform: "GOOGLE" })
                    }}
                    onError={() => {
                        console.log('Login Failed');
                    }}
                    />
                </>
              )}
            </Fragment>
          )}
        <div>
        
          
        </div>
        </form>
      </AuthLayout>
      <div className="my-3 text-end">
        <div className="text-center mb-3">
          Already Have an account?
          <NavLink className="signup" to="/auth/login">
            {" "}
            Login
          </NavLink>
          .
        </div>
      </div>
    </Fragment>
  );
};

export default Body;
